module.exports = window["core-js/modules/es.string.iterator.js"];